import { ws } from "../../../utils/common";

export const postUserQuestion = async ({ id_association, question }) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "user-question/" + id_association,
    null,
    { question },
    true
  );

  if (res.error) {
    throw res.data;
  } else {
    return res.data;
  }
};
